import * as React from 'react';

type Props =
  | (React.ComponentProps<'article'> & { as?: 'article' })
  | (React.ComponentProps<'li'> & { as?: 'li' });

export const baseCardStyle = 'rounded-lg shadow bg-white';
export const clickableCardStyle =
  'hover:ring-1 ring-grey-900 hover:ring-opacity-20';

export const Card: React.FC<Props> = ({
  className = '',
  as = 'article',
  ...props
}) => {
  return React.createElement(as, {
    className: `p-4 ${baseCardStyle} ${className}`,
    ...props,
  });
};
